var loadVuePlugin = function loadVuePlugin(vueLib, plugin) {
  try {
    plugin && vueLib.use(plugin);
    console.info('zone-plugin-loader#loadVuePlugin/info: plugin loaded');
  } catch (e) {
    if (e instanceof TypeError) {
      console.warn('zone-plugin-loader#loadVuePlugin/info: No customizations found');
    } else {
      console.error('zone-plugin-loader#loadVuePlugin/error: something went wrong\n', e);
    }
  }
};

var loadStorePlugins = function loadStorePlugins(storeInstance, storeModules) {
  try {
    if (!storeModules || typeof storeModules !== 'object') return;
    Object.entries(storeModules).forEach(function (_ref) {
      var name = _ref[0],
        module = _ref[1];
      return storeInstance.registerModule(name, module, {
        preserveState: true
      });
    });
    console.info('zone-plugin-loader#loadStorePlugins/info: store modules loaded');
  } catch (e) {
    if (e instanceof TypeError) {
      console.warn('zone-plugin-loader#loadStorePlugins/info: No customizations found');
    } else {
      console.error('zone-plugin-loader#loadStorePlugins/error: something went wrong\n', e);
    }
  }
};

var load = function load(vueLib, storeInstance) {
  var ZONE_CUSTOMIZATION_PLUGIN_NAME = process.env.VUE_APP_LOCAL_ZONE_CUSTOMIZATION_GLOBAL_VAR !== undefined && window[process.env.VUE_APP_LOCAL_ZONE_CUSTOMIZATION_GLOBAL_VAR];
  try {
    var _window$ZONE_CUSTOMIZ = window[ZONE_CUSTOMIZATION_PLUGIN_NAME],
      plugin = _window$ZONE_CUSTOMIZ["default"],
      storeModules = _window$ZONE_CUSTOMIZ.storeModules;
    loadVuePlugin(vueLib, plugin);
    loadStorePlugins(storeInstance, storeModules);
    console.info('zone-plugin-loader#load/info: store modules loaded');
  } catch (e) {
    if (e instanceof TypeError) {
      console.warn('zone-plugin-loader#load/info: No customizations found');
    } else {
      console.error('zone-plugin-loader#load/error: something went wrong\n', e);
    }
  }
};

export default load;
//# sourceMappingURL=zone-plugin-loader.esm.js.map
